export default __webpack_public_path__ + "images/0x5fd55a1b9fc24967c4db09c513c3ba0dfa7ff687.png";